export enum DiscountType {
  PERCENTAGE,
  DIRECT
}
